import parenthood1 from '../../Assets/parenthood1.png';
import parenthood2 from '../../Assets/parenthood2.png';
import parenthood3 from '../../Assets/parenthood3.png';
import parenthood4 from '../../Assets/parenthood4.png';
import parenthood5 from '../../Assets/parenthood5.png';
import daycare1 from '../../Assets/daycare1.png'
import daycare2 from '../../Assets/daycare2.png'
import daycare3 from '../../Assets/daycare3.png'
import daycare4 from '../../Assets/daycare4.png'
import daycare5 from '../../Assets/daycare5.png'
import special1 from "../../Assets/special1.png"
import special2 from "../../Assets/special2.png"
import special3 from "../../Assets/special3.png"
import special4 from "../../Assets/special4.png"
import special5 from "../../Assets/special5.png"
import takeabreak1 from "../../Assets/takeabreak1.png"
import takeabreak2 from "../../Assets/takeabreak2.png"
import takeabreak3 from "../../Assets/takeabreak3.png"
import takeabreak4 from "../../Assets/takeabreak4.png"
import takeabreak5 from "../../Assets/takeabreak5.png"
import helping from '../../Assets/helping-you-image.png'
import sleep1 from "../../Assets/sleep1.png"
import sleep2 from "../../Assets/sleep2.png"
import sleep3 from "../../Assets/sleep3.png"
import sleep4 from "../../Assets/sleep4.png"
import sleep5 from "../../Assets/sleep5.png"
import ourselves1 from "../../Assets/ourselves1.png"
import ourselves2 from "../../Assets/ourselves2.png"
import ourselves3 from "../../Assets/ourselves3.png"
import ourselves4 from "../../Assets/ourselves4.png"
import mansi from "../../Assets/mansi.png"
import vinod from "../../Assets/vinod.png" 
import adithyaLogo from "../../Assets/hs1.png"
import kamalaLogo from "../../Assets/hs2.png"
import novacareLogo from "../../Assets/hs3.png"
import toddler1 from "../../Assets/toddler1.png"
import toddler2 from "../../Assets/toddler2.png"
import toddler3 from "../../Assets/toddler3.png"
import toddler4 from "../../Assets/toddler4.png"
import toddler5 from "../../Assets/toddler5.png"
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import babycareimg2 from "../../Assets/babycareimg2.png"

 
export const serviceShowcaseData = [
  {
    imgSrc: babycareimg2,
    title: `Cuddles & Care \n For Your Precious \n Little One`,
    buttonText: "Book Now",
    onButtonClick: () => console.log("Button Clicked"),
  }
]

// text details
export const heading = "Where Love Meets Little Feet";

export const paragraph = `Bringing a new life into the world is indeed one of the most precious and joyous experiences for any family. \nOur baby care services are designed to make the early days of parenthood easier and more \n enjoyable for you, providing reliable support and expert care for your newborn.`;

// data object
export const parenthood = {
  a1: { title: "Grooming", img: parenthood1 },
  a2: { title: "Bathing", img: parenthood2 },
  a3: { title: "Toileting", img: parenthood3 },
  a4: { title: "Cradling", img: parenthood4 },
  a5: { title: "Feeding", img: parenthood5 },
};

export const daycare = {
  Grooming: { title: "Feeding", img: daycare1 },
  Bathing: { title: "Body Massage", img: daycare2 },
  Toileting: { title: "Grooming", img: daycare3 },
  Cradling: { title: "Nappy Change", img: daycare4 },
  Feeding: { title: "Safety & Comfort", img: daycare5 },
};

export const toddlercare = [
   { title: "Foster Social Skills", img: toddler1 },
    { title: "Language Development", img: toddler2 },
  { title: "Motor Skill Development", img: toddler3 },
    { title: "Toileting Habits", img: toddler4 },
    { title: "Structured Activities", img: toddler5},
];

export const special = {
  Grooming: { title: "Care Planning", img: special1 },
  Bathing: { title: "Feeding Support", img: special2 },
  Toileting: { title: "Behavioural Management", img: special3 },
  Cradling: { title: "Therapeutic Interventions", img: special4 },
  Feeding: { title: "Transition Planning", img: special5 },
};

export const takeabreak = {
  Grooming: { title: "First Time Parents", img: takeabreak1 },
  Bathing: { title: "Single Parent", img: takeabreak2 },
  Toileting: { title: "Ones With Premature Borns", img: takeabreak3 },
  Cradling: { title: "Employed Parents", img: takeabreak4 },
  Feeding: { title: "C-Section Mothers", img: takeabreak5 },
};

export const helpingyoudata = {
  heading: `Helping You Juggle Life's Many Joys`,
  para: `At Wihan, we understand that being a parent is a beautiful journey filled
with countless joys, but it can also be overwhelming at times. That's where
we come in. Our baby caregiver services are designed to provide you with
the support and assistance you need to navigate parenthood with ease.`,

  para2: `From expertly handling feeding and diapering to engaging your baby in
stimulating activities that promote growth and development, our 
caregivers are committed to providing a nurturing and safe environment
for your child. We understand that every family is unique, so we tailor our
services to meet your specific needs and preferences.`,
  image: helping
}

export const sleepSpecialists = {
  Grooming1: { title: "Assess New Born Sleep Needs", img: sleep3 },
  Grooming2: { title: "Putting Baby To Sleep", img: sleep2 },
  Grooming3: { title: "Baby Proofing", img: sleep4 },
  Grooming4: { title: "Guidance On Night Time Nursing", img: sleep5 },
  Grooming5: { title: "Nappy Change", img: sleep1 },
}

export const ourselves = {
  Grooming: { title: "One To One Care", img: ourselves1 },
  Bathing: { title: "Certified Team", img: ourselves2 },
  Toileting: { title: "Constantly Trained", img: ourselves3 },
  Cradling: { title: "Health and Hygiene", img: ourselves4 },
};

export const happyparents = [
  {
    desc: `We've been using Wihan home health care services for our baby's
care, and we couldn't be happier. The caregivers are not only
skilled and attentive but also genuinely caring and nurturing.
It gives us such peace of mind knowing our little one is in good
hands while we're at work."`,
    userimg: mansi,
    username: "Mansi"

  },
  {
    desc: `Our experience with Wihan baby care services has been nothing short
of amazing. Our baby has thrived in their care, and we can see the
positive impact it's had on her development. The environment is safe,
stimulating, and filled with love, and we couldn't ask for more."`,
    userimg: vinod,
    username: "Vinod",
  },
  {
    desc: `Our experience with Wihan baby care services has been nothing short
of amazing. Our baby has thrived in their care, and we can see the
positive impact it's had on her development. The environment is safe,
stimulating, and filled with love, and we couldn't ask for more."`,
    userimg: mansi,
    username: "Priya",
  },
];

export const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover: false,
  pauseOnFocus: false,
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 2, arrows: false } },
    { breakpoint: 768, settings: { slidesToShow: 2, arrows: false } },
    { breakpoint: 480, settings: { slidesToShow: 1, arrows: false } },
  ],
};


export const truncateLetters = (str, num) => {
  return str.length > num ? str.slice(0, num) + "..." : str;
};

export const babycarehospitals = [
 { name: 'SHRI ADITHYA Hospitals', logo: adithyaLogo },
  { name: 'SRESHTA SRI KAMALA HOSPITALS', logo: kamalaLogo },
  { name: 'NOVACARE HOSPITALS', logo: novacareLogo },
];

export const settings2 = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,        // enable autoplay
  autoplaySpeed: 3000,   // 3 seconds
  responsive: [
    {
      breakpoint: 1200,
      settings: { slidesToShow: 3 }
    },
    {
      breakpoint: 992,
      settings: { slidesToShow: 2 }
    },
    {
      breakpoint: 600,
      settings: { slidesToShow: 1 }
    }
  ]
};

export const settings3 = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,        // enable autoplay
  autoplaySpeed: 3000,   // 3 seconds,
  arrows:false,
  responsive: [
    {
      breakpoint: 1200,
      settings: { slidesToShow: 3}
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 3 }
    },
    {
      breakpoint: 480,
      settings: { slidesToShow: 2 }
    },
      {
      breakpoint: 380,
      settings: { slidesToShow: 1 }
    }
  ]
};
